import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorConvert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-9 2.25a.75.75 0 0 1 .75.75 8.25 8.25 0 0 0 13.913 6H16.5a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-1.214A9.719 9.719 0 0 1 12 21.75c-5.385 0-9.75-4.365-9.75-9.75a.75.75 0 0 1 .75-.75Z"
    />
    <path
      fill="#F7A600"
      d="M6.338 6a8.25 8.25 0 0 1 13.912 6 .75.75 0 0 0 1.5 0c0-5.385-4.365-9.75-9.75-9.75a9.72 9.72 0 0 0-6.75 2.714V3.75a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H6.338Z"
    />
  </svg>
);
export default SvgTwoColorConvert;
